declare global {
  interface Window {
    __SIGCHAT_EARLY_UNIFIED_MANIFEST__?: Promise<unknown>
  }
}

export function takeEarlyUnifiedManifest(): Promise<unknown> | undefined {
  const pending = window.__SIGCHAT_EARLY_UNIFIED_MANIFEST__
  if (!pending) return undefined
  delete window.__SIGCHAT_EARLY_UNIFIED_MANIFEST__
  return pending
}
